export default {
  socialHousingLoan: {
    percentage: [
      '­-0,180',
      '-0,154',
      '-0,304',
      '-0,466',
      '-0,477',
      '2,629',
      '4,160',
      '2,691',
      '2,187'
    ],
    dataTableOnMobileApp: [
      {
        year: '2018',
        percentage: '-0,180'
      },
      {
        year: '2019',
        percentage: '-0,154'
      },
      {
        year: '2020',
        percentage: '-0,304'
      },
      {
        year: '2021',
        percentage: '-0,466'
      },
      {
        year: '2022',
        percentage: '-0,477'
      },
      {
        year: '2023',
        percentage: '2,629'
      },
      {
        year: '2024',
        percentage: '4,160'
      },      
      {
        year: '2025',
        percentage: '2,691',
      },
      {
        year: '2026',
        percentage: '2,187',
      },
    ],
    years: [
      '2018',
      '2019',
      '2020',
      '2021',
      '2022',
      '2023',
      '2024',
      '2025',
      '2026'
    ],
    loanTerm: [
      'Hasta 15 años',
      'Hasta 20 años',
      'Hasta 25 años',
      'Hasta 30 años',
    ],
    percentageFixed: [
      '0,128',
      '-0,069',
      '­-0,180',
      '-0,154',
    ],
    dataTableFixedOnMobileApp: [
      {
        loanTerm: 'Hasta 15 años',
        percentage: '0,128',
      },
      {
        loanTerm: 'Hasta 20 años',
        percentage: '-0,069',
      },
      {
        loanTerm: 'Hasta 25 años',
        percentage: '-0,180'
      },
      {
        loanTerm: 'Hasta 30 años',
        percentage: '-0,154'
      }
    ],
  },
  agreementHousingLoan: {
    percentage: [
      '0,000',
      '0,000',
      '0,000',
      '0,000',
      '0,000',
      '2,780',
      '4,202',
      '2,697',
      '2,346'
    ],
    dataTableOnMobileApp: [
      {
        year: '2018',
        percentage: '0,000',
      },
      {
        year: '2019',
        percentage: '0,000',
      },
      {
        year: '2020',
        percentage: '0,000',
      },
      {
        year: '2021',
        percentage: '0,000',
      },
      {
        year: '2022',
        percentage: '0,000',
      },
      {
        year: '2023',
        percentage: '2,780',
      },
      {
        year: '2024',
        percentage: '4,202',
      },     
      {
        year: '2025',
        percentage: '2,697',
      },
      {
        year: '2026',
        percentage: '2,346',
      },
    ],
    years: [
      '2018',
      '2019',
      '2020',
      '2021',
      '2022',
      '2023',
      '2024',
      '2025',
      '2026'
    ],

    loanTerm: [
      'Hasta 15 años',
      'Hasta 20 años',
      'Hasta 25 años',
      'Hasta 30 años',
    ],
    
    percentageFixed: [
      '0,128',
      '-0,069',
      '­-0,180',
      '-0,154',
    ],

    dataTableFixedOnMobileApp: [
      {
        loanTerm: 'Hasta 15 años',
        percentage: '0,128',
      },
      {
        loanTerm: 'Hasta 20 años',
        percentage: '-0,069',
      },
      {
        loanTerm: 'Hasta 25 años',
        percentage: '-0,180'
      },
      {
        loanTerm: 'Hasta 30 años',
        percentage: '-0,154'
      }
    ],
  },
  variousCredit: {
    percentage: [
      '0,820',
      '0,846',
      '0,696',
      '0,534',
      '0,523',
      '3,629',
      '5,160',
      '3,691',
      '3,187'
    ],
    dataTableOnMobileApp: [
      {
        year: '2018',
        percentage: '0,820',
      },
      {
        year: '2019',
        percentage: '0,846',
      },
      {
        year: '2020',
        percentage: '0,696',
      },
      {
        year: '2021',
        percentage: '0,534',
      },
      {
        year: '2022',
        percentage: '0,523',
      },
      {
        year: '2023',
        percentage: '3,629',
      },
      {
        year: '2024',
        percentage: '5,160'
      },
      {
        year: '2025',
        percentage: '3,691',
      },
      {
        year: '2026',
        percentage: '3,187',
      },
    ],
    years: [
      '2018',
      '2019',
      '2020',
      '2021',
      '2022',
      '2023',
      '2024',
      '2025',
      '2026'
    ],
  },
  diversalAtention: {
    percentage: [
      '0,761',
      '0,795',
      '3,880',
      '5,302',
      '3,797',
      '3,446'
    ],
    dataTableOnMobileApp: [
      {
        year: '2021',
        percentage: '0,761',
      },
      {
        year: '2022',
        percentage: '0,795',
      },
      {
        year: '2023',
        percentage: '3,880',
      },
      {
        year: '2024',
        percentage: '5,302'
      },
      {
        year: '2025',
        percentage: '3,797'
      },
      {
        year: '2026',
        percentage: '3,446'
      }
    ],
    years: [
      '2021',
      '2022',
      '2023',
      '2024',
      '2025',
      '2026'
    ],
  },
};



// WEBPACK FOOTER //
// ./client/app/loans.module/common/services/static/dataBasicCharacteristicsTable.js